export const BANNER = 'banner';

export const adServerClients = {
  KEVEL: 'KEVEL'
};

export const bannerImplementationTypes = {
  LEGACY: 'legacy',
  UBC: 'ubc'
};

export const bannerTypes = {
  HERO: 'hero',
  STANDARD: 'standard',
  MIDDLE: 'middle', // pip,
  INGRID: 'ingrid',
  SKYSCRAPER: 'skyscraper',
  LEADERBOARD: 'leaderboard'
};

export const schemas = {
  SEARCH_SPONSORED: 'search_sponsored',
  BROWSE_SPONSORED: 'browse_sponsored',
  CAT_SPONSORED: 'cat_sponsored',
  PIP_SPONSORED: 'pip_sponsored',
  LOCALAD_SPONSORED: 'localad_sponsored',
  OC_SPONSORED: 'oc_sponsored',
  NO_RESULTS_FOUND_SPONSORED: 'no_results_found_sponsored',
  HP_SPONSORED: 'hp_sponsored',
  HP_SPONSORED_AUTH: 'hp_sponsored_auth',
  STOREPAGE_SPONSORED: 'storepage_sponsored',
  THANKYOUPAGE_SPONSORED: 'thankyoupage_sponsored',
  INGRID_SPONSORED: 'ingrid_sponsored',
  CART_SPONSORED: 'cart_sponsored',
  EVENT_BROWSE_SPONSORED: 'event_browse_sponsored',
  ATC_SPONSORED: 'atc_sponsored',
};

export const CLICK_CONVERSION_BEACON_TIME_TO_LIVE = 2419200000;
export const VIEW_CONVERSION_BEACON_TIME_TO_LIVE = 1209600000;
export const SUPPRESSED_NVALUES = 'fs-prop:sponsored-content-suppressed-nvalues';
export const HOMEPAGE_BORDER_RADIUS = 12;
